module.exports = {
  permission: {
    permission_RealMap: "实时图",
    permission_TileMap: "污染云图",
    permission_RoadAss: "污染自动拍照",
    permission_RoadStatistics: "道路统计",
    permission_FaultIden: "故障自动识别报警",
    permission_FaultAbnormal: "故障自动识别报警",
    permission_HistoryMap: "历史轨迹",
    permission_DataAnalysis: "设备质控",
    permission_StationManage: "基础信息",
    permission_HighValue: "高值分析",
    permission_Panorama: "道路全景",
    permission_CaliSetting: "校准设置",
    permission_PollutionAlarm: "自动污染报警",
    permission_DataDownload: "数据下载",
    permission_HourStatistics: "时段统计",
    permission_StationStatistics: "设备数据统计",
    permission_RoadInterLayer: "道路插值图",
    permission_ReportManage: "报表管理",
    permission_RoadTileLayer: "道路云图",
    permission_TaskList: "任务列表",
    permission_TaskStat: "仪表盘",
    permission_WzAnalysis: "微站月报表",
    permission_WzPollutionIndex: "微站污染分析",
  },
  message: {
    label_vehicle_monitor: "走航大气监测系统",
    label_login: "登录",
    label_username: "用户名",
    label_password: "密码",
    label_keep_signed_in: "记住密码",
    label_login: "登录",
    label_logged_successfully: "登录成功",
    label_logged_failed: "失败",
    label_London_vehicle: "伦敦走航监测管理系统",
    label_sign_out: "退出登录",
    label_update_key: "修改口令",
    label_project_config: "项目配置",
    label_update_password: "修改密码",

    label_standard: "显示标站",
    label_display_standard_name: "标站名称",
    label_pollution_cloud_image: "污染云图",
    label_standard_color: "标准",
    label_enhanced_color: "增强",
    label_plate_number: "车牌号",
    label_alarm_pictures: "显示报警图片",
    label_online_quantity: "今日在线数量",
    label_near_24h_online_quantity: "近24小时在线数量",
    m5online: "实时在线",
    h24online: "近24小时在线",
    offline: "设备离线",
    label_today_online_rate: "今日在线率",
    label_near_24h_online_rate: "近24小时在线率",
    label_total: "总计数量",
    label_average_PM25: "PM₂.₅均值",
    label_average_PM10: "PM₁₀均值",
    label_No: "序号",
    label_SN: "设备号",
    label_PM25: "PM₂.₅",
    label_PM10: "PM₁₀",
    label_time_update: "更新时间",
    label_speed: "速度",
    label_single_device_display: "单台设备显示",
    label_view_video: "查看视频",
    label_online_rate: "在线率",

    //污染云图
    label_point_filtering: "点数过滤",
    label_pollution_point: "污染点",
    label_comparison_standard: "标站对比",
    label_district_county_ranking: "区县排名",
    label_street_town_ranking: "街镇排名",
    label_custom_area: "自定义区域",
    label_clean_ranking: "清洁排名",
    label_pollution_ranking: "污染排名",
    label_display_pollution_point: "显示污染点",
    label_road: "道路",
    label_district_county: "区县",
    label_street_town: "街镇",
    label_location: "位置",
    label_number_of_points: "点个数",
    label_refresh: "刷新",
    label_export: "导出",
    label_name: "名称",
    label_grade: "级别",
    label_surrounding_PM10: "周边PM₁₀",
    label_surrounding_PM25: "周边PM₂.₅",
    label_number_of_points: "点个数",
    label_country: "国",
    label_province: "省",
    label_city: "市",
    label_district: "区",
    label_street_town: "街镇",
    label_improvement_PM10: "PM₁₀改善率",
    label_improvement_PM25: "PM₂.₅改善率",
    label_filter_size: "滤波器大小",
    label_number_of_points_region: "区域点统计个数",
    label_point_spacing: "点间隔（米）",
    label_selection_area: "选择地区",
    label_filtering: "滤波",
    label_get_rid_unknown_road: "无名路",
    label_pollution_point_name: "污染点名称",
    label_operate: "操作",
    label_display: "显示",
    label_hide: "隐藏",
    label_location_data: "位置数据",
    label_number_of_vehicles: "车次",
    label_average_number_of_vehicles: "日均车辆数",
    label_print_chart: "打印图表",
    label_download_PNG: "下载PNG文件",
    label_download_JPEG: "下载JPEG文件",
    label_download_PDF: "下载PDF文件",
    label_download_SVG: "下载SVG文件",
    label_download_CSV: "下载CSV文件",
    label_download_XLS: "下载XLS文件",
    label_view_data_tables: "查看数据表格",
    label_menu: "菜单"
  },
  placeholder: {
    label_search: "输入设备号搜索",
    label_type_of_standard_station: "选择标站类型"
  }
};
